import { render, staticRenderFns } from "./AcordoFechado.vue?vue&type=template&id=622d9038"
import script from "./AcordoFechado.vue?vue&type=script&lang=js"
export * from "./AcordoFechado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports